import React from "react"
import Link from "next/link"

const ToConclude  = () => {
  return (
    <div className="section-py bg-grey">
  <div className="container lg:container mx-auto">
    <div className="row grid lg:grid-cols-12">
      <div className="text-center lg:col-span-8 lg:col-start-3 mx-auto">
        <h2 data-aos="fade-up" data-aos-duration="700" data-aos-delay="100" className="mb-2.5">To Conclude</h2>
        <p data-aos="fade-up" data-aos-duration="700" data-aos-delay="100" className="mb-50 fw-600">It is also crucial for you to keep in mind your financial budget, several modules, functionalities, and features if you wish to develop uber clone app. Also, the cost of developing taxi app would vary according to the ridesharing app development company you hire and their expertise. So, if are you looking for a leading taxi app development service provider to develop an application like UBER/Ola/Lyft, then talk to the Moweb experts today!</p>
        <Link href="/contact-us" className="btn btn-primary">
        Contact Us Now
        </Link>
      </div>
    </div>
  </div>
</div>
  )
}

export default ToConclude
